import { useCourseFormOptionsQuery } from '@treneo/features/config';
import { useAppTranslations } from '@treneo/shared/i18n';

import type { CourseFormOptions } from '../types';

interface UseCourseFormOptionsResult {
  formOptions: CourseFormOptions | null;
  isLoadingOptions: boolean;
  optionsError: string | null;
  isBasicDataLoaded: boolean;
}

type UseCourseFormOptionsParams = {
  enabled?: boolean;
};

export const useCourseFormOptions = (
  params?: UseCourseFormOptionsParams
): UseCourseFormOptionsResult => {
  const { t } = useAppTranslations();
  const enabled = params?.enabled ?? true;

  const query = useCourseFormOptionsQuery({ enabled });

  const formOptions = query.data ?? null;
  const isLoadingOptions = query.isLoading;
  const optionsError = query.error
    ? query.error instanceof Error
      ? query.error.message
      : t('courseForm.errorLoadingOptions')
    : null;
  const isBasicDataLoaded = !isLoadingOptions && !!formOptions;

  return {
    formOptions,
    isLoadingOptions,
    optionsError,
    isBasicDataLoaded
  };
};
